import React from 'react';
import { ReactComponent as DinInIcon } from "../../../assets/images/icon-plate-list.svg";
import { ReactComponent as CollectionIcon } from "../../../assets/images/icon-bag-list.svg";
import { ReactComponent as BicycleIcon } from "../../../assets/images/icon-bicycle-list.svg";
import { OrderTypes } from "../constants"
import { useTranslation } from "react-i18next";

interface OrderTypeIconProps {
  orderType: string | undefined;
  fill?: string;
}
export default function OrderTypeIcon({ orderType, fill = "#FFDD02" }: OrderTypeIconProps) {
  const { t } = useTranslation();

  const renderOrderTypeIcon = () => {
    switch (orderType) {
      case OrderTypes.TABLE_DELIVERY:
        return <div>
          <div>
            <DinInIcon fill={fill} />
          </div>
          <div> <p>{t("orderHistory.table.TABLE_DELIVERY")}</p> </div>
        </div>
      case OrderTypes.COLLECTION:
        return <div>
          <div>
            <CollectionIcon fill={fill} />
          </div>
          <div> <p>{t("orderHistory.table.COLLECTION")}</p> </div>
        </div>
      case OrderTypes.PICKUP_NOW:
        return <div>
          <div>
            <CollectionIcon fill={fill} />
          </div>
          <div> <p>{t("orderHistory.table.PICKUP_NOW")}</p> </div>
        </div>
      case OrderTypes.HOME_DELIVERY:
        return <div>
          <div>
            <BicycleIcon fill={fill} />
          </div>
          <div> <p>{t("orderHistory.table.HOME_DELIVERY")}</p> </div>
        </div>
      default:
        break;
    }
  }
  return (
    <>
      {renderOrderTypeIcon()}
    </>
  )
}
